const INTENT_PREFIX = 'intent:';
const CONTENT_TARGET_PREFIX = 'target:';

export const parseScheduledAppTarget = (value) => {
  const raw = String(value || '').trim();
  if (raw.startsWith('assigned:')) return { mode: 'assigned', packageName: '', contentTargetId: null };
  const contentTarget = raw.toLowerCase().startsWith(CONTENT_TARGET_PREFIX);
  const intent = raw.toLowerCase().startsWith(INTENT_PREFIX);
  return {
    mode: contentTarget ? 'target' : intent ? 'intent' : 'package',
    packageName: String(intent ? raw.slice(INTENT_PREFIX.length) : contentTarget ? '' : raw).trim(),
    contentTargetId: contentTarget ? Number(raw.slice(CONTENT_TARGET_PREFIX.length)) || null : null,
  };
};

export const encodeScheduledAppTarget = (packageName, mode = 'package') => {
  const normalized = String(packageName || '').trim();
  if (!normalized) return '';
  return mode === 'intent' ? `${INTENT_PREFIX}${normalized}` : normalized;
};

export const encodeScheduledContentTarget = (targetId) => {
  const normalized = Number(targetId);
  return Number.isInteger(normalized) && normalized > 0 ? `${CONTENT_TARGET_PREFIX}${normalized}` : '';
};

export const hasIntentLaunchRecipe = (profile) => {
  const recipe = profile?.profile?.launchRecipe;
  return recipe?.enabled === true
    && recipe?.launch?.type === 'uri'
    && Boolean(String(recipe.launch.uri || '').trim());
};
